var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"wheels-button",class:{
  'wheels-button__primary': _vm.variant === 'primary',
  'wheels-button__secondary': _vm.variant === 'secondary',
  'wheels-button__link': _vm.variant === 'link',
  'wheels-button__plain': _vm.variant === 'plain',
  'wheels-button__icon': _vm.icon !== undefined,
  'wheels-button__icon-left': _vm.icon !== undefined && _vm.iconPosition === 'left',
  'wheels-button__icon-right': _vm.icon !== undefined && _vm.iconPosition === 'right',
},attrs:{"disabled":_vm.disabled},on:{"click":_setup.handleClick}},[_c('span',{staticClass:"wheels-button__content"},[(_vm.icon)?_c(_setup.WheelsSvgIcon,{staticClass:"wheels-button__icon",attrs:{"icon":_vm.icon,"size":"1rem"}}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }